import Vue from "vue";

export default function KeyInputPattern() {
    const inputOnFocus = function (ev) {
        ev.target.setSelectionRange(0, 0);
    };

    const inputOnKeyDown = function (ev, sections) {
        // Backspace 8, Delete 46, Left 37, Tab 9, End 35
        if (ev.keyCode === 8 || ev.keyCode === 46 || ev.keyCode === 37 || ev.keyCode === 9 || ev.keyCode === 35) return;

        let content = sections.map(() => "");
        let incorrectSuffix = "";
        let pos = {s: 0, p: 0};
        let writeTo = {s: -1, p: -1};

        if (ev.target.value.length === 0) {
            writeTo.s = 0;
            writeTo.p = 0;
        } else {
            for (let i = 0; i < ev.target.value.length; i++) {
                if (pos.s >= sections.length) {
                    incorrectSuffix = ev.target.value.substr(i);
                    break;
                }

                let charCode = ev.target.value.charCodeAt(i);
                let contentType = charCode >= 48 && charCode <= 57 ? "number" : "string";
                let expectedType = "";

                if (sections[pos.s].t === "static") {
                    expectedType = "string";
                } else {
                    if (pos.p + 1 <= sections[pos.s].max) expectedType = "number";
                    if (pos.p + 1 > sections[pos.s].min) {
                        if (pos.s + 1 < sections.length && sections[pos.s + 1].t === "static") expectedType += "string";
                    }
                }

                if (contentType === "string" && expectedType === "numberstring") {
                    pos.s++;
                    pos.p = 0;
                    expectedType = "string";
                }

                if (i === ev.target.selectionStart) {
                    writeTo.s = pos.s;
                    writeTo.p = pos.p;
                }

                if (contentType === "string" && expectedType.indexOf("string") >= 0) {
                    if (ev.target.value[i] === sections[pos.s].content[pos.p]) {
                        content[pos.s] += ev.target.value[i];
                        if (pos.p + 1 === sections[pos.s].max) {
                            if (pos.s + 1 < sections.length) {
                                pos.s++;
                                pos.p = 0;
                            } else {
                                pos.s = 100;
                                pos.p = -1;
                            }
                        } else {
                            pos.p++;
                        }
                        continue;
                    }

                    incorrectSuffix = ev.target.value.substr(i);
                    break;
                } else if (contentType === "number" && expectedType.indexOf("number") >= 0) {
                    content[pos.s] += ev.target.value[i];
                    if (pos.p + 1 === sections[pos.s].max) {
                        if (pos.s + 1 < sections.length) {
                            pos.s++;
                            pos.p = 0;
                        } else {
                            pos.s = 100;
                        }
                    } else {
                        pos.p++;
                    }
                    continue;
                }

                incorrectSuffix = ev.target.value.substr(i);
                break;
            }

            // if cursor is at the end of input string
            if (ev.target.value.length === ev.target.selectionStart) {
                // if format is not fully correct add cursor to the last correct section
                if (pos.s !== 100) {
                    writeTo.s = pos.s;
                    writeTo.p = pos.p;
                }
                // if format is already fully correct do not append anything
                if (pos.s === 100 && incorrectSuffix === "") {
                    ev.preventDefault();
                    return;
                }
            }
        }

        if (writeTo.s >= 0) {
            ev.preventDefault();

            let selectPos = ev.target.selectionStart;
            let dirty = false;

            // Right, Space, or current separator
            if (
                ev.keyCode === 39 ||
                ev.keyCode === 32 ||
                (sections[writeTo.s].t === "static" && ev.key === sections[writeTo.s].content[writeTo.p])
            ) {
                // if current section is static
                if (sections[writeTo.s].t === "static") {
                    if (content[writeTo.s] !== sections[writeTo.s].content) {
                        dirty = true;
                        content[writeTo.s] = sections[writeTo.s].content;
                    }
                    selectPos += sections[writeTo.s].content.length - writeTo.p;
                }
                // if current section is number
                else {
                    // if current section is complete
                    if (
                        content[writeTo.s].length >= sections[writeTo.s].min &&
                        writeTo.p >= content[writeTo.s].length
                    ) {
                        writeTo.s++;
                        if (content[writeTo.s] !== sections[writeTo.s].content) {
                            dirty = true;
                            content[writeTo.s] = sections[writeTo.s].content;
                        }
                        selectPos += content[writeTo.s].length;
                    } else {
                        selectPos += 1;
                    }
                }
            }
            // if next separator is typed
            else if (
                sections.length > writeTo.s + 1 &&
                sections[writeTo.s + 1].t === "static" &&
                ev.key === sections[writeTo.s + 1].content[0]
            ) {
                if (content[writeTo.s].length >= sections[writeTo.s].content[0]) {
                    writeTo.s++;
                    writeTo.p = 0;
                    if (content[writeTo.s] !== sections[writeTo.s].content) {
                        dirty = true;
                        content[writeTo.s] = sections[writeTo.s].content;
                    }
                    selectPos += content[writeTo.s].length;
                }
            }
            // if number is typed
            else if ((ev.keyCode >= 48 && ev.keyCode <= 57) || (ev.keyCode >= 93 && ev.keyCode <= 105)) {
                selectPos += 1;
                // if cursor is on static section
                if (sections[writeTo.s].t === "static") {
                    // if cursor is at the beginning of static section and previous section is not full then move to the previous section
                    if (writeTo.p === 0 && content[writeTo.s - 1].length < sections[writeTo.s - 1].max) {
                        writeTo.s--;
                        writeTo.p = content[writeTo.s].length;
                    }
                    // write static section and move to next section
                    else {
                        content[writeTo.s] = sections[writeTo.s].content;
                        selectPos += content[writeTo.s].length;
                        writeTo.s++;
                        writeTo.p = 0;
                    }
                }

                let sectionFull = content[writeTo.s].length === sections[writeTo.s].max;
                // if cursor is on the last position of the section
                if (writeTo.p + 1 === sections[writeTo.s].max) {
                    // if next session is static then write static content
                    if (writeTo.s + 1 < sections.length && sections[writeTo.s + 1].t === "static") {
                        selectPos += sections[writeTo.s + 1].content.length;
                        content[writeTo.s + 1] = sections[writeTo.s + 1].content;
                    }
                }

                content[writeTo.s] =
                    content[writeTo.s].substr(0, writeTo.p) +
                    ev.key +
                    content[writeTo.s].substr(writeTo.p + (sectionFull ? 1 : 0), content[writeTo.s].length);
                dirty = true;
            }

            if (dirty) ev.target.value = content.join("") + incorrectSuffix;
            ev.target.setSelectionRange(selectPos, selectPos);
        }
    };


    return {
        inputOnFocus,
        inputOnKeyDown,
    };
}
